import { Alert, Card, Divider, Snackbar } from "@mui/material";
import { PostBody } from "./post_body";

import { AuthorBar } from "./author-bar/author-bar.component";
import { PostBottomBar } from "./bottom-bar/bottom-bar.component";
import { PostData, PostProps, PostStateMixin } from "./post.models";

import { View } from "../utils/view";
import { PostController } from "./post.controller";

import { getUsernameFor } from "../utils/username";
import { CommentViewer } from "./comments/comment-viewer/comment-viewer.component";
import CommentsReply from "./comments/comments-reply/comments-reply.component";
import "./post.css";

export class Post extends View<
  PostProps,
  PostData & PostStateMixin,
  PostController<PostData>
> {
  constructor(props: PostProps) {
    super(props, props.controller);
  }

  render() {
    let postContainerClassName = "post-container";

    if (this.props.showValidationErrors && this.props.hasErrors) {
      postContainerClassName += " has-errors";
    }

    return (
      <Card
        id={this.state.id}
        className={postContainerClassName}
        variant="outlined"
      >
        <AuthorBar {...this.state} />
        <PostBody
          data={this.state}
          onQuizCompleted={this.controller.onQuizCompleted}
        />
        <Divider />
        <PostBottomBar
          {...this.state}
          onDislikeClicked={this.controller.onDislikeClicked}
          onLikeClicked={this.controller.onLikeClicked}
          onShareClicked={this.controller.onShareClicked}
          likes={this.state.likes ?? 0}
          dislikes={this.state.dislikes ?? 0}
          shares={this.state.shares ?? 0}
        />
        <Divider />
        <CommentViewer {...this.state} />
        <CommentsReply
          visible={(this.state.comments ?? []).length > 0}
          user={this.props.user}
          onSubmitted={this.controller.onCommentSubmitted}
        />
        <Snackbar
          open={this.state.displayShareSnackbar}
          autoHideDuration={6000}
          onClose={this.controller.onShareDismissed}
          message="Post shared successfully!"
        />
        <Snackbar
          open={this.state.displayReplyFollowup}
          autoHideDuration={6000}
          onClose={this.controller.onReplyFollowupDismissed}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={this.controller.onReplyFollowupDismissed}
            severity="info"
            variant="filled"
            sx={{
              width: "35%",
              minWidth: "300px",
              fontSize: "1.2rem",
              padding: "16px 24px",
              "& .MuiAlert-icon": { fontSize: "24px" },
            }}
          >
            {`${this.state.userFollowup != null ? getUsernameFor(this.state.userFollowup?.user) : "Someone"} liked your comment!`}
          </Alert>
        </Snackbar>
      </Card>
    );
  }
}
